import { render, staticRenderFns } from "./RoleResponsibilitiesTab.vue?vue&type=template&id=db87d914&scoped=true"
import script from "./RoleResponsibilitiesTab.vue?vue&type=script&setup=true&lang=js"
export * from "./RoleResponsibilitiesTab.vue?vue&type=script&setup=true&lang=js"
import style0 from "./RoleResponsibilitiesTab.vue?vue&type=style&index=0&id=db87d914&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db87d914",
  null
  
)

export default component.exports